import * as React from "react";
import { useCallback, useContext } from "react";
import { Form, Formik } from "formik";
import isFunction from "lodash/isFunction";
import FormWarningsContext from "contexts/FormWarningsContext";
import validate from "views/components/searchbar/validate";
import { isNoTimeRangeOverride } from "views/typeGuards/timeRange";
import usePluginEntities from "hooks/usePluginEntities";
import useUserDateTime from "hooks/useUserDateTime";
import useHandlerContext from "views/components/useHandlerContext";
import useSearchBarSubmit from "views/components/searchbar/useSearchBarSubmit";
import { onInitializingTimerange } from "./TimerangeForForm";
const _isFunction = (children) => isFunction(children);
const DashboardSearchForm = ({ initialValues, limitDuration, onSubmit, validateQueryString, children }) => {
  const { formatTime, userTimezone } = useUserDateTime();
  const { setFieldWarning } = useContext(FormWarningsContext);
  const pluggableSearchBarControls = usePluginEntities("views.components.searchBar");
  const { timerange, ...rest } = initialValues;
  const initialTimeRange = timerange && !isNoTimeRangeOverride(timerange) ? onInitializingTimerange(timerange, formatTime) : {};
  const _initialValues = {
    timerange: initialTimeRange,
    ...rest
  };
  const { enableReinitialize, onSubmit: _onSubmit } = useSearchBarSubmit(_initialValues, onSubmit);
  const handlerContext = useHandlerContext();
  const _validate = useCallback(
    (values) => validate(
      values,
      limitDuration,
      setFieldWarning,
      validateQueryString,
      pluggableSearchBarControls,
      formatTime,
      handlerContext,
      userTimezone
    ),
    [
      limitDuration,
      setFieldWarning,
      validateQueryString,
      pluggableSearchBarControls,
      formatTime,
      handlerContext,
      userTimezone
    ]
  );
  return /* @__PURE__ */ React.createElement(
    Formik,
    {
      initialValues: _initialValues,
      enableReinitialize,
      onSubmit: _onSubmit,
      validate: _validate,
      validateOnMount: true
    },
    (...args) => /* @__PURE__ */ React.createElement(Form, null, _isFunction(children) ? children(...args) : children)
  );
};
export default DashboardSearchForm;
